export const te = {
	content: `
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882" xmlns="http://www.w3.org/TR/REC-html40">
    <head>
        <meta http-equiv=Content-Type content="text/html; charset=utf-8">
        <meta name=ProgId content=Word.Document>
        <meta name=Generator content="Microsoft Word 14">
        <meta name=Originator content="Microsoft Word 14">
        <link rel=File-List href="Finvu (CTPL)_Terms and Conditions_Tam_html.files/filelist.xml">
        <title>Finvu</title>
        <!--[if gte mso 9]><xml><o:DocumentProperties><o:Author>Mr. Jaipreet Singh Chhatwal</o:Author><o:LastAuthor>Mukthyar Lukmandin</o:LastAuthor><o:Revision>1</o:Revision><o:Pages>4</o:Pages><o:Characters>23176</o:Characters><o:Lines>188</o:Lines><o:Paragraphs>154</o:Paragraphs></o:DocumentProperties><o:CustomDocumentProperties><o:GrammarlyDocumentId dt:dt="string" >68ffa36e7d9bbf332e92e069fa30ea69ccd30aff8bdce869d49b9b87b83fa573</o:GrammarlyDocumentId><o:KSOProductBuildVer dt:dt="string" >1033-12.2.0.20795</o:KSOProductBuildVer><o:ICV dt:dt="string" >89B1FBECF0054EBF8299FF533392BB41_13</o:ICV></o:CustomDocumentProperties></xml><![endif]-->
        <!--[if gte mso 9]><xml><o:OfficeDocumentSettings></o:OfficeDocumentSettings></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:WordDocument><w:BrowserLevel>MicrosoftInternetExplorer4</w:BrowserLevel><w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery><w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery><w:DocumentKind>DocumentNotSpecified</w:DocumentKind><w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing><w:PunctuationKerning></w:PunctuationKerning><w:View>Web</w:View><w:Compatibility><w:DontGrowAutofit/><w:DoNotExpandShiftReturn/></w:Compatibility><w:Zoom>0</w:Zoom></w:WordDocument></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:LatentStyles DefLockedState="false"  DefUnhideWhenUsed="true"  DefSemiHidden="true"  DefQFormat="false"  DefPriority="99"  LatentStyleCount="260" >
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Normal" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="heading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footer" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="35"  SemiHidden="false"  QFormat="true"  Name="caption" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of figures" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope return" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="line number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="page number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of authorities" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="macro" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="toa heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="10"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Title" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Closing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="1"  SemiHidden="false"  Name="Default Paragraph Font" ></w:LsdException>
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Body Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Message Header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="11"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Subtitle" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Salutation" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Date" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Note Heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Block Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Hyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="FollowedHyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="22"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Strong" ></w:LsdException>
<w:LsdException Locked="false"  Priority="20"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Emphasis" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Document Map" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Plain Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="E-mail Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal (Web)" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Acronym" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Cite" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Code" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Definition" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Keyboard" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Preformatted" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Sample" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Typewriter" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Variable" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Table" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation subject" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / a / i" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / 1.1 / 1.1.1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Article / Section" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Contemporary" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Elegant" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Professional" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Balloon Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Table Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Theme" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Placeholder Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No Spacing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Paragraph" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Intense Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 6" ></w:LsdException>
</w:LatentStyles></xml><![endif]-->
        <style>
            @font-face {
                font-family: "Times New Roman";
            }

            @font-face {
                font-family: "宋体";
            }

            @font-face {
                font-family: "Courier New";
            }

            @font-face {
                font-family: "Wingdings";
            }

            @font-face {
                font-family: "Arial";
            }

            @font-face {
                font-family: "Anek Telugu";
            }

            @list l0:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l0:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l1:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l2:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l3:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l4:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l5:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l6:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level1 {
                mso-level-start-at: 3;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l7:level2 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l7:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l8:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l9:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l10:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l11:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level1 {
                mso-level-start-at: 4;
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l12:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l13:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level1 {
                mso-level-start-at: 2;
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l14:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l15:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l16:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l17:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l18:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level1 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l19:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l20:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l21:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l22:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l23:level2 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l23:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            p.MsoNormal {
                mso-style-name: Normal;
                mso-style-parent: "";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Courier New';
                color: rgb(0,0,0);
                font-size: 12.0000pt;
            }

            span.10 {
                font-family: 'Courier New';
            }

            span.15 {
                font-family: 'Times New Roman';
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 10.0000pt;
            }

            span.16 {
                font-family: Arial;
                color: rgb(22,28,45);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 7.5000pt;
            }

            span.17 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            span.18 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            p.19 {
                mso-style-name: "Header or footer \(2\)";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Times New Roman';
                color: rgb(0,0,0);
                font-size: 10.0000pt;
            }

            p.MsoBodyText {
                mso-style-name: "Body Text";
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            p.21 {
                mso-style-name: "Heading \#1";
                margin-top: 29.0000pt;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                mso-outline-level: 1;
                font-family: Arial;
                color: rgb(22,28,45);
                font-size: 7.5000pt;
            }

            p.22 {
                mso-style-name: Other;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            span.msoIns {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: underline;
                text-underline: single;
                color: blue;
            }

            span.msoDel {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: line-through;
                color: red;
            }

            table.MsoNormalTable {
                mso-style-name: "Table Normal";
                mso-style-parent: "";
                mso-style-noshow: yes;
                mso-tstyle-rowband-size: 0;
                mso-tstyle-colband-size: 0;
                mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
                mso-para-margin: 0pt;
                mso-para-margin-bottom: .0001pt;
                mso-pagination: widow-orphan;
                font-family: 'Times New Roman';
                font-size: 10.0000pt;
                mso-ansi-language: #0400;
                mso-fareast-language: #0400;
                mso-bidi-language: #0400;
            }

            @page {
                mso-page-border-surround-header: no;
                mso-page-border-surround-footer: no;
            }

            @page Section0 {
                margin-top: 9.1000pt;
                margin-bottom: 21.4000pt;
                margin-left: 67.7000pt;
                margin-right: 22.1000pt;
                size: 612.0000pt 792.0000pt;
                layout-grid: 18.0000pt;
                mso-header-margin: 0.0000pt;
                mso-footer-margin: 0.1500pt;
                mso-footer: url("Finvu%20\(CTPL\)_Terms%20and%20Conditions_Tam_html.files/header.html") f0;
            }

            div.Section0 {
                page: Section0;
            }
        </style>
    </head>
    <body style="tab-interval:36pt;text-justify-trim:punctuation;">
        <!--StartFragment-->
        <div class="Section0" style="layout-grid:18.0000pt;">
            <p class=21 align=justify style="page-break-after:avoid;mso-pagination:lines-together;text-align:justify;
text-justify:inter-ideograph;">
                <a name="bookmark0"></a>
                <span class="16" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:22.5pt;">సేవా నిబంధనలు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-size:7.5000pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:24.0000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">జనవరి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-2025</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">న నవీకరించబడింది</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నియమనిబంధనలు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిబంధనలు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") Finvu </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అప్లికేషన్ మరియు వెబ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సైట్ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు సేవల ప్రాప్యత మరియు వినియోగాన్ని నియంత్రిస్తాయి </span>
                <i style="mso-bidi-font-style:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">(</span>
                </i>
                <i>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:italic;
font-variant:normal;font-size:12.75pt;">క్రింద నిర్వచించబడిన</span>
                </i>
                <i style="mso-bidi-font-style:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">).</span>
                </i>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-align:justify;text-justify:inter-ideograph;">
                <span>
                    <a href="http://www.finvu.in/privacy">
                        <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">www.finvu.in/privacy</span>
                    </a>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో లభించే మా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(“</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">గోప్యతా విధానం</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">”) &nbsp;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు ఎప్పటికప్పుడు మేము అందుబాటులో ఉంచిన లేదా జారీ చేసిన ఏవైనా మార్గదర్శకాలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అదనపు నిబంధనలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">విధానాలు లేదా నిరాకరణలు కూడా ఇందులో ఉన్నాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలను మేము ఇక్కడ పేర్కొన్న నిబంధనలకు అనుగుణంగా సవరించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు కాలానుగుణంగా సవరించబడిన నిబంధనలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు వర్తిస్తాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు వేదికలో ఈ నిబంధనల యొక్క ప్రస్తుత వెర్షన్ను ఎల్లప్పుడూ సమీక్షించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Cookiejar Technologies Private Limited ("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">కంపెనీ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">", "</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">", "</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">Finvu</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">", </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">మాకు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవల యొక్క ఏదైనా వినియోగదారు మరియు మా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వాతావరణాన్ని </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉపయోగించే ఏదైనా ఆర్థిక సమాచార ప్రదాత లేదా ఆర్థిక సమాచార వినియోగదారు మధ్య ఒక బంధన మరియు అమలు చేయగల చట్టపరమైన ఒప్పందాన్ని ఏర్పరుస్తాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. Cookiejar Technologies Private Limited RBI </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ద్వారా లైసెన్స్ పొందింది మరియు ఖాతా అగ్రిగేటర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గా పనిచేయడానికి </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India (RBI) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మంజూరు చేసిన రిజిస్ట్రేషన్ సర్టిఫికేట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను కలిగి ఉంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కంపెనీ వద్ద </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">చట్టం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 1934 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లోని సెక్షన్ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">45 IA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కింద </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">జారీ చేసిన </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">06 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మార్చి </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2020 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నాటి చెల్లుబాటు అయ్యే రిజిస్ట్రేషన్ సర్టిఫికేట్ ఉంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(a) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలను అంగీకరించడానికి మరియు కట్టుబడి ఉండటానికి మీకు పూర్తి చట్టపరమైన సామర్థ్యం మరియు అధికారం ఉందని</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (b) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఒక వ్యక్తి అయితే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు పద్దెనిమిది సంవత్సరాలు లేదా అంతకంటే ఎక్కువ వయస్సు ఉంటే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">18 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంవత్సరాల కంటే తక్కువ వయస్సు ఉంటే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలను ఉపయోగించడానికి మీరు తల్లిదండ్రుల లేదా చట్టపరమైన సంరక్షకుల సహాయం తీసుకోవాలి మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(c) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">భారతీయ నివాసి అని మీరు ప్రాతినిధ్యం వహిస్తున్నారు మరియు హామీ ఇస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఒక ఎంటిటీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంస్థ లేదా ఏదైనా ఇతర చట్టపరమైన వ్యక్తికి ప్రాతినిధ్యం వహిస్తే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అటువంటి ఎంటిటీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంస్థ లేదా చట్టపరమైన వ్యక్తిని ఈ నిబంధనలకు కట్టుబడి ఉంచడానికి మీకు అవసరమైన అధికారం మరియు అజమాయిషీ ఉందని మీరు ధృవీకరిస్తారు మరియు ప్రాతినిధ్యం వహిస్తారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-align:justify;text-justify:inter-ideograph;line-height:144%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా వేదిక</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉపయోగించడం ద్వారా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఈ నిబంధనలను చదివి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అర్థం చేసుకున్నారని మరియు వాటికి కట్టుబడి ఉన్నారని మరియు ఇక్కడ జాబితాలో పేర్కొన్న అవసరాలకు అనుగుణంగా ఉన్నారని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఈ నిబంధనలన్నింటికీ అంగీకరించకపోతే లేదా ఇక్కడ జాబితాలో పేర్కొనబడిన అవసరాలకు అనుగుణంగా లేకపోతే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">దయచేసి వేదికను యాక్సెస్ చేయవద్దు లేదా సేవలు మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉపయోగించవద్దు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.1000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        1.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిర్వచనాలు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:157%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">AA </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">మాస్టర్ డైరెక్షన్స్</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనగా</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">https://www.rbi.or</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">g</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">.in/Scripts/BS_ViewMasDirections.asDx?id= 10598</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అందుబాటులో ఉన్న సరిదిద్దబడిన</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సవరించబడిన లేదా కాలానుగుణంగా నవీకరించబడిన మాస్టర్ డైరెక్షన్ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">- </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నాన్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బ్యాంకింగ్ ఫైనాన్షియల్ కంపెనీ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">- </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అకౌంట్ అగ్రిగేటర్ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(Reserve Bank) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డైరెక్షన్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 2016;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ ఆదేశాల ప్రయోజనం కోసం </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">కస్టమర్</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంటే మేము అందించే సేవలను పొందడానికి లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మాస్టర్ ఆదేశాల క్రింద నిర్వచించబడిన సేవలను పొందడానికి మాతో ఒప్పంద అమరిక కుదుర్చుకున్న </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">'</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వ్యక్తి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">';</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచారం</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనేది </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మాస్టర్ డైరెక్షన్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో దానికి ఆపాదించబడిన అదే అర్థాన్ని కలిగి ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇందులో ఆర్థిక సమాచార ప్రదాత వద్ద అందుబాటులో ఉన్న మీ ఆర్థికపరమైన డేటా ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార ప్రదాత</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంటే బ్యాంకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బ్యాంకింగ్ కంపెనీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బ్యాంకింగేతర ఫైనాన్షియల్ కంపెనీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆస్తి నిర్వహణ కంపెనీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డిపాజిటరీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డిపాజిటరీ భాగస్వామి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బీమా కంపెనీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బీమా రిపోజిటరీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పెన్షన్ ఫండ్ లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మాస్టర్ డైరెక్షన్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార ప్రదాత</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గా గుర్తించబడే అటువంటి ఇతర సంస్థ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార వినియోగదారు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంటే ఏదైనా ఆర్థిక రంగ నియంత్రణ సంస్థతో నమోదు చేయబడిన మరియు నియంత్రించబడే సంస్థ లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మాస్టర్ డైరెక్షన్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార వినియోగదారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గా గుర్తించబడే అటువంటి ఇతర సంస్థ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 10.8500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక రంగ నియంత్రణ సంస్థ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనే పదానికి </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మాస్టర్ డైరెక్షన్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో ఆపాదించబడిన అదే అర్థం ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">వ్యక్తిగత సమాచారం</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">వ్యక్తిగత డేటా</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంటే అటువంటి డేటా ద్వారా లేదా దానికి సంబంధించి గుర్తించదగిన వ్యక్తి గురించి ఏదైనా డేటా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">RBI</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">” </font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంటే </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అని అర్థం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 10.6000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">Sandbox</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంటే వేదిక యొక్క అందుబాటులో ఉన్న పరీక్షా వాతావరణం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇది ఆర్థిక సమాచార ప్రదాత మరియు ఆర్థిక సమాచార వినియోగదారు మా సమర్పణలను అంచనా వేయడానికి అనుమతిస్తుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిబంధనలలో పెద్ద అక్షరాలలో ఉన్న కానీ ఈ నిబంధన </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">1</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో నిర్వచించబడకపోయిన పదాలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిర్దిష్ట నిబంధనలో వాటికి ఆపాదించబడిన అర్థాన్నే కలిగి ఉంటాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        2.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పరిధి</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఖాతా ఏకీకరణ సేవలు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">": </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక ద్వారా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 10.6000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార ప్రదాతల వద్ద అందుబాటులో ఉన్న ఆర్థిక సమాచారాన్ని తిరిగి పొందవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">చూడవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏకీకృతం చేయవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిర్వహించవచ్చు మరియు పంచుకోవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ ఆర్థిక సమాచారాన్ని ఆర్థిక సమాచార వినియోగదారులకు అందించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కస్టమరుకు వేదిక యాక్సెస్ను అందించడంతో పాటు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక ద్వారా మేము అందించే ఖాతా ఏకీకరణ సేవలను</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, "</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గా సూచిస్తారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము మీకు సేవలను అందించడానికి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలలోని నిబంధన </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">6 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రకారం మీ సమ్మతితో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార ప్రదాతల నుండి మీ ఆర్థిక సమాచారాన్ని యాక్సెస్ చేయడానికి పరిమిత అధికారంతో మమ్మల్ని మీ ఏజెంట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గా మీరు ఇందుమూలంగా అధికారం ఇస్తున్నారు మరియు నియమిస్తున్నారు మరియు మీ అవసరానికి అనుగుణంగా ఆర్థిక సమాచార వినియోగదారులతో కూడా పంచుకుంటున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్తించే చట్టాలకు అనుగుణంగా సేవలకు మీకు ఛార్జీ విధించే హక్కు మాకు ఉంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము సేవలకు వసూలు చేయాలని అనుకుంటే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">రుసుములు మా వేదికలో అందుబాటులో ఉన్న మా ధరల విధానానికి అనుగుణంగా ఉంటాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అదనంగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">భవిష్యత్తులో ఏవైనా రుసుములు భవిష్యత్తులో విధించబడతాయి మరియు ఈ సందర్భంలో మీకు ముందస్తు వ్రాతపూర్వక నోటీసు అందించబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రొఫైల్ సృష్టి</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలను పొందడానికి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు వేదికలో </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రొఫైల్</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఒక ప్రొఫైల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను సృష్టించాల్సి ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రొఫైల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను సృష్టించడానికి వినియోగదారు పేరు మరియు పాస్వర్డ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను సెటప్ చేయడంతో పాటు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్తించే చట్టాల ప్రకారం అవసరమైన పేరు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇమెయిల్ చిరునామా మరియు ఫోన్ నంబర్లతో సహా కానీ వాటికి మాత్రమే పరిమితం కాకుండా కొన్ని వివరాలను మీరు అందించాల్సి ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ ప్రొఫైల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కు సంబంధించి అందించిన సమాచారం అంతా ఖచ్చితమైనది మరియు నిజమైనది అని మీరు హామీ ఇస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు ఈ సమాచారంలో ఏదైనా మార్పు లేదా సవరణ జరిగినప్పుడు వేదికలో మీ వివరాలను వెంటనే అప్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డేట్ చేయాలని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:145%;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">హ్యాండిల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">యూజర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నేమ్ మరియు పాస్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్డ్ యొక్క భద్రత మరియు గోప్యతను కాపాడుకోవడానికి మీరు పూర్తిగా బాధ్యత వహిస్తారు మరియు మీ ప్రొఫైల్ యొక్క ఏదైనా వెల్లడి లేదా అనధికారిక ఉపయోగం లేదా మీ ప్రొఫైల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కు సంబంధించి ఏదైనా ఇతర భద్రతా ఉల్లంఘన గురించి వెంటనే మాకు తెలియజేయడానికి అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వెంటనే మాకు నివేదిస్తారు మరియు మీకు తెలిసిన లేదా అనుమానించబడిన సేవల యొక్క ఏదైనా అనధికార వినియోగాన్ని ఆపడానికి సహేతుకమైన ప్రయత్నాలను ఉపయోగిస్తారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ii) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలను యాక్సెస్ చేయడానికి లేదా ఉపయోగించడానికి తప్పుడు గుర్తింపు సమాచారాన్ని అందించరు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. "</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">AA </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">హ్యాండిల్</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంటే మా వేదికలో మీ రిజిస్ట్రేషన్ సమయంలో ఉత్పత్తి చేయబడిన ఒక ప్రత్యేక ఐడెంటిఫయర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">దీనిని వేదికని యాక్సెస్ చేయడానికి మరియు సేవలను అందించడానికి పార్టీలు ఉపయోగిస్తాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ ప్రొఫైల్ ద్వారా జరిగే అన్ని కార్యకలాపాలకు బాధ్యత వహించడానికి మరియు జవాబుదారీగా ఉండటానికి మీరు స్పష్టంగా అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ ప్రొఫైల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కు అనధికారిక యాక్సెస్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కు మేము ఏ విధంగానూ బాధ్యత వహించము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ అనుచిత వినియోగం వల్ల ప్రత్యక్షంగా లేదా పరోక్షంగా సంభవించే ఏదైనా డేటా లేదా కార్యాచరణ నష్టానికి మేము బాధ్యత వహించము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;text-indent:7.0000pt;tab-stops:left blank 21.1500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.1<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:157%;mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవల యొక్క కొన్ని లక్షణాలను పొందాలనుకునే వేదిక యొక్క వినియోగదారులకు సంబంధించి మేము కొన్ని </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నో యువర్ కస్టమర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" (</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ కస్టమర్ను తెలుసుకోండి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రక్రియలను చేపట్టాల్సి రావచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ విషయంలో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఎప్పటికప్పుడు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవల యొక్క కొన్ని లక్షణాలను </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">KYC </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">పత్రాలు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉపయోగించడానికి మీ అర్హతను నిర్ధారించడానికి అవసరమైన సమాచారం మరియు పత్రాలను అప్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లోడ్ చేయమని మేము మిమ్మల్ని కోరుతాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పత్రాలను ప్రాసెస్ చేయడానికి మరియు మీ అర్హతను నిర్ధారించడానికి మీరు మాకు మరియు మేము నిమగ్నమయ్యే ఏదైనా మూడవ పక్ష సేవా ప్రదాతకు అధికారం ఇస్తారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము చేపట్టే ఏదైనా ప్రాసెసింగ్ మా గోప్యతా విధానానికి అనుగుణంగా ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధన కింద మూడవ పక్షం సమాచారాన్ని ప్రాసెస్ చేస్తే మీరు అదనపు సేవా నిబంధనలకు లోబడి ఉండవచ్చని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇంకా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అర్హతను నిర్ణయించడానికి ఏదైనా అదనపు సమాచారం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డేటా లేదా డాక్యుమెంటేషన్ అవసరమైతే </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమిష్టిగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, "</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">అదనపు సమాచారం</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"), </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అభ్యర్థన మేరకు అటువంటి అదనపు సమాచారాన్ని వెంటనే పంచుకోవడానికి మీరు ఇందుమూలంగా అంగీకరిస్తున్నారు మరియు అంతేకాకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అటువంటి అదనపు సమాచారాన్ని ప్రాసెస్ చేయడానికి మాకు అధికారం ఇస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు నిజమైన</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పూర్తి మరియు తాజా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పత్రాలు మరియు అదనపు సమాచారాన్ని అందించడానికి అంగీకరిస్తున్నారు మరియు హామీ ఇస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇంకా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ విషయంలో అందించబడిన ఏదైనా తప్పుడు లేదా తప్పుదారి పట్టించే సమాచారం ఈ నిబంధనల యొక్క ముఖ్యమైన ఉల్లంఘనగా పరిగణించబడుతుంది మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ii) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పత్రాలు మరియు అదనపు సమాచారాన్ని పంచుకోవడంలో విఫలమైతే సేవల యొక్క కొన్ని లక్షణాలకు మీ యాక్సెస్ పరిమితం చేయబడవచ్చు లేదా తిరస్కరించబడవచ్చు అని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;text-indent:7.0000pt;tab-stops:left blank 21.1500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.2<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డేటాను ఉపయోగించడానికి సమ్మతి</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము మీ ఆర్థిక సమాచారాన్ని నిల్వ చేయము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">యాక్సెస్ చేయము లేదా చూడము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. ReBIT (Reserve Bank Information Technology Private Limited) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిర్వచించిన </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సాంకేతిక వివరణల ప్రకారం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రొఫైల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను సృష్టించడానికి మరియు మీ ఆర్థిక ఖాతాలను కనుగొనడంలో మీకు సహాయపడటానికి మేము మీ మొబైల్ నంబర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను సేకరించి ధృవీకరిస్తాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ సమ్మతి సంబంధిత చర్యల గురించి </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">SMS </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నోటిఫికేషన్లను పంపడానికి మీ మొబైల్ నంబర్ గుప్తీకరించబడిన ఆకృతిలో సురక్షితంగా నిల్వ చేయబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అదనంగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">FIP</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కి అవసరమైతే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, FIP </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లింక్ చేయబడిన ఖచ్చితమైన ఖాతాలను కనుగొనడంలో సహాయపడటానికి మీ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">PAN </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు పుట్టిన తేదీని మాస్క్ చేయబడిన రూపంలో </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ReBIT </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నుండి ప్రచురించబడిన </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సాంకేతిక వివరణల ప్రకారం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) Finvu AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వ్యవస్థ ద్వారా పంపబడతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. PAN </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు పుట్టిన తేదీ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Finvu AA</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో అస్సలు నిల్వ చేయబడవు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;">
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;">
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 19.0500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా సేవల నిబంధన మీ ఆర్థిక సమాచారాన్ని వెల్లడించడానికి మరియు బదిలీ చేయడానికి మీ సమ్మతిని అందించడానికి మిమ్మల్ని అనుమతిస్తుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమ్మతిని సేకరించి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమ్మతి కళాకృతిని ఉపయోగించడం ద్వారా నిర్ధారించబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">దీని కోసం మీరు ఈ క్రింది డేటాసెట్లను ధృవీకరించాల్సి ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:12.0000pt;tab-stops:left blank 22.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ గుర్తింపు మరియు ఐచ్ఛిక సంప్రదింపు సమాచారం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:12.0000pt;tab-stops:left blank 23.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అభ్యర్థించిన ఆర్థిక సమాచారం యొక్క స్వభావం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అటువంటి సమాచారాన్ని సేకరించే ఉద్దేశ్యం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:12.0000pt;tab-stops:left blank 212.75pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమాచారం అందుకున్న వారి గుర్తింపు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:12.0000pt;tab-stops:left blank 23.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమాచారాన్ని యాక్సెస్ చేయడానికి సమ్మతి పత్రాన్ని ఉపయోగించిన ప్రతిసారీ నోటిఫికేషన్ పంపాల్సిన </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">URL </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా ఇతర చిరునామా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమ్మతి సృష్టి తేదీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమ్మతి గడువు తేదీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు మీ సంతకం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డిజిటల్ సంతకం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్తించే చట్టం ప్రకారం అవసరమయ్యే ఏదైనా ఇతర సమాచారం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు సంబంధించిన ఏదైనా ఆర్థిక సమాచారాన్ని పొందేందుకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమ్మతి పత్రం ద్వారా మాకు అందించిన మీ సమ్మతి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మొత్తాన్ని లేదా దేనినైనా మీరు ఏ సమయంలోనైనా రద్దు చేసుకోవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">రద్దు చేసిన తర్వాత</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార ప్రదాత మరియు ఆర్థిక సమాచార వినియోగదారునికి అటువంటి నోటిఫికేషన్ గురించి తెలియజేయబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు మరియు వేదికలో సమాచారం పంచుకున్న ఆర్థిక సమాచార వినియోగదారులు అందించిన సమ్మతుల రికార్డును మీరు ఏ సమయంలోనైనా యాక్సెస్ చేయవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="text-indent:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా గోప్యతా విధానానికి అనుగుణంగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ వ్యక్తిగత సమాచారం మరియు సాంకేతిక డేటా మరియు సంబంధిత సమాచారాన్ని మేము సేకరించి ఉపయోగించవచ్చని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:7.0000pt;tab-stops:left blank 17.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక యొక్క ప్రభావాన్ని మరియు సామర్థ్యాన్ని మరింత మెరుగుపరచడానికి విశ్లేషణలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ధోరణుల గుర్తింపు మరియు గణాంకాల కోసం వేదికలోని మీ సేవలు మరియు కార్యకలాపాల వినియోగానికి సంబంధించిన ఆర్థిక సమాచారం మరియు డేటాను మినహాయించి మేము సమాచారాన్ని ఉపయోగించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:0.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్తించే చట్టాలకు లోబడి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">క్రిమినల్ చర్యలు లేదా ఏదైనా ఇతర చర్యలకు సంబంధించి మీకు సంబంధించిన డేటాను వెల్లడించమని చట్ట అమలు సంస్థలు లేదా ప్రభుత్వం మరియు సంబంధిత నియంత్రణ సంస్థలు మమ్మల్ని ఆదేశించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అటువంటి సందర్భాలలో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంబంధిత ఏజెన్సీలు లేదా సంస్థలతో అటువంటి డేటాను పంచుకునే హక్కు మాకు ఉంటుందని మీరు అర్థం చేసుకున్నారు మరియు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        4.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నోటిఫికేషన్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కంపెనీ మీ రిజిస్టర్డ్ ఇమెయిల్ ఐడి లేదా ఫోన్ నంబర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కు కాలానుగుణంగా నోటీసులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉత్తరప్రత్యుత్తరాలు లేదా హెచ్చరికలను పంపవచ్చని మరియు సేవలను అందించడానికి అవసరమైన ముఖ్యమైన ఉత్తరప్రత్యుత్తరాలను మీరు నిలిపివేయలేకపోవచ్చునని మీరు అర్థం చేసుకున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు హెచ్చరికలు లేదా ఉత్తరప్రత్యుత్తరాల యొక్క స్వీకరణను నిలిపివేసిన సందర్భంలో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలను ఉత్తమంగా ఉపయోగించడం కోసం దానిని సవరించి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">హెచ్చరికల స్వీకరణను దాని సరైన గమ్యస్థానానికి సక్రియం చేయాలని కంపెనీ మీకు సిఫార్సు చేస్తుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కంపెనీ నుండి వచ్చే ఉత్తరప్రత్యుత్తరాలు ఖచ్చితంగా సేవలకు సంబంధించినవి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        5.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా బాధ్యతలు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ స్పష్టమైన సమ్మతి ఆధారంగా మేము మీకు సేవలను అందిస్తాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు సేవలను అందించడం అనేది మాకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు మరియు ఆర్థిక సమాచార వినియోగదారులకు మధ్య తగిన ఒప్పందాలు మరియు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా అధికారాల ద్వారా మద్దతు ఇవ్వబడిందని మేము నిర్ధారిస్తాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు సంబంధించిన మరియు సేవలకు సంబంధించి మేము ప్రాసెస్ చేసే ఎటువంటి ఆర్థిక సమాచారాన్ని మేము నిల్వ చేయము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఖాతా ఏకీకరణ వ్యాపారాన్ని చేపట్టడానికి మేము మూడవ పక్ష సేవా ప్రదాత సేవలను ఉపయోగించము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వివిధ ఆర్థిక సమాచార ప్రదాతలతో ఉన్న ఖాతాలకు సంబంధించిన మీ వినియోగదారు ప్రామాణీకరణ ఆధారాలను మేము యాక్సెస్ చేయము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        6.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ బాధ్యతలు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలకు అంగీకరించిన తేదీన సేవల ద్వారా లేదా సేవలకు సంబంధించి అందించబడిన మొత్తం సమాచారం సంపూర్ణమైనది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిజమైనది మరియు సరైనదని మరియు మీరు సేవలను పొందుతున్నంత వరకు పూర్తి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిజమైనది మరియు సరైనదిగా కొనసాగుతుందని మీరు ప్రాతినిధ్యం వహిస్తున్నారు మరియు హామీ ఇస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు అమలులో ఉన్నప్పుడు మీరు అందించే ఏదైనా సమాచారం మారితే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు వెంటనే ఆ మార్పును మా దృష్టికి తీసుకురావడానికి మరియు మీ ప్రొఫైల్ ద్వారా వెంటనే దాన్ని నవీకరించడానికి బాధ్యత వహిస్తారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక ద్వారా మీరు ప్రసారం చేసే సమాచారం యొక్క విషయాలపై మేము ఎటువంటి నియంత్రణను కలిగి ఉండమని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలను పొందడానికి అందించిన ఏదైనా సమాచారం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డాక్యుమెంటేషన్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మెటీరియల్ లేదా డేటా తప్పుగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అసంపూర్ణంగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సరికానిదిగా లేదా తప్పుదారి పట్టించేదిగా ఉంటే లేదా మీరు ఏదైనా ముఖ్యమైన వాస్తవాన్ని వెల్లడించడంలో విఫలమైతే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు కలిగే ఏదైనా నష్టం లేదా నష్టానికి మేము ఎటువంటి బాధ్యత లేదా జవాబుదారీని స్వీకరించము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్తించే చట్టాలకు అనుగుణంగా ఉండేలా చూసుకోవడం మీ పూర్తి బాధ్యత మరియు ఈ విషయంలో మీ బాధ్యతలను ఉల్లంఘించడం వల్ల తలెత్తే ఏదైనా బాధ్యతకు మీరు పూర్తిగా బాధ్యత వహించాలి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనల ప్రకారం మీ బాధ్యతలు లేదా ఒడంబడికలను ఉల్లంఘించడం వల్ల మాకు వ్యతిరేకంగా ప్రారంభించబడే ఏవైనా చర్యలకు సంబంధించి మీరు మాకు పూర్తి సహకారాన్ని అందించాలి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        7.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిషేధించబడిన కార్యకలాపాలు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l13 level1 lfo13;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలలో స్పష్టంగా అనుమతించబడిన విధంగా తప్ప</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు సేవలను ఏ విధంగానూ ఉపయోగించకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మునుపటి వాక్యం యొక్క సాధారణతను పరిమితం చేయకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఇవి చేయకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కాపీ చేయడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సవరించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుకూలీకరించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనువదించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">రివర్స్ ఇంజనీర్ చేయడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డీకంపైల్ చేయడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">విడదీయడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మార్చడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పునరుత్పత్తి చేయడం లేదా వేదికకు ఏవైనా మార్పులు చేయడం లేదా ఏదైనా ఉత్పన్న పనులను సృష్టించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మూడవ పక్షాలకు టైమ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">షేరింగ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రమాణాలను నిర్దేశించడం లేదా ఇతర కంప్యూటర్ సేవలను అందించడానికి ఏదైనా మైమర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో వేదికను ఉపయోగించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇక్కడ స్పష్టంగా అందించినవి తప్ప</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా మూడవ పక్షం ప్లాట్ఫారమ్ యొక్క కార్యాచరణను యాక్సెస్ చేయడానికి లేదా ప్రయోజనం పొందడానికి అనుమతించడం లేదా ఏదైనా పోటీ లేదా సారూప్య ఉత్పత్తిని అభివృద్ధి చేయడానికి వేదికను ఉపయోగించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 13.0000pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వైరస్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ట్రోజన్ హార్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వార్మ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">టైమ్ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బాంబ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కీస్ట్రోక్ లాగర్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">స్పైవేర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">యాడ్వేర్ లేదా ఏదైనా కంప్యూటర్ సాఫ్ట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేర్ లేదా హార్డ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేర్ ఆపరేషన్ను ప్రతికూలంగా ప్రభావితం చేయడానికి లేదా ఏదైనా కంప్యూటర్ వనరు యొక్క కార్యాచరణను నాశనం చేయడానికి లేదా పరిమితం చేయడానికి రూపొందించబడిన ఏదైనా ఇతర హానికరమైన ప్రోగ్రామ్లు లేదా ఇలాంటి కంప్యూటర్ కోడ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లను కలిగి ఉన్న ఏదైనా డేటాను ప్రసారం చేయడానికి లేదా పంపడానికి లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అప్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లోడ్ చేయడానికి సేవలను ఉపయోగించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 12.5000pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక లేదా దానిలోని ఏదైనా భాగాన్ని పర్యవేక్షించడానికి లేదా కాపీ చేయడానికి ఏదైనా రోబోట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">స్పైడర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇతర ఆటోమేటెడ్ పరికరం లేదా మాన్యువల్ ప్రక్రియను ఉపయోగించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా పేటెంట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ట్రేడ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మార్క్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కాపీరైట్ లేదా ఇతర యాజమాన్య హక్కులను ఉల్లంఘించడం</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 13.0000pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వ్యక్తులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అధికారులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డైరెక్టర్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉద్యోగులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏజెంట్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అధీకృత ప్రతినిధులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఫోరమ్ నాయకులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గైడ్లు లేదా అతిథేయిలతో సహా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కానీ వీటికే పరిమితం కాకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా వ్యక్తి లేదా సంస్థ వలె నటించడం లేదా తప్పుగా ప్రాతినిధ్యం వహించడం లేదా ఏదైనా సమాచారం లేదా ఖాతాలను తప్పుగా పేర్కొనడం లేదా తప్పుగా ప్రాతినిధ్యం వహించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 13.9500pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సందేశం యొక్క మూలం గురించి పేర్కొనబడిన వ్యక్తిని మోసం చేయడం లేదా తప్పుదారి పట్టించడం లేదా తెలిసి మరియు ఉద్దేశపూర్వకంగా ఏదైనా తప్పుడు సమాచారం లేదా సమాచారాన్ని తెలియజేయడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇది పూర్తిగా తప్పుడు మరియు అసత్యం లేదా తప్పుదారి పట్టించే స్వభావం కలిగి ఉంటుంది లేదా కేంద్ర ప్రభుత్వ వ్యాపారానికి సంబంధించి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మంత్రిత్వ శాఖ అధికారిక గెజిట్లో ప్రచురించబడిన నోటిఫికేషన్ ద్వారా పేర్కొన్న విధంగా కేంద్ర ప్రభుత్వ వాస్తవ తనిఖీ విభాగం నకిలీ లేదా తప్పుడు లేదా తప్పుదారి పట్టించేదిగా గుర్తించబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 15.1500pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (viii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">భారతదేశ ఐక్యత</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమగ్రత</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">రక్షణ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">భద్రత లేదా సార్వభౌమత్వాన్ని</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">విదేశాలతో స్నేహపూర్వక సంబంధాలను లేదా ప్రజా క్రమాన్ని బెదిరించడం లేదా ఏదైనా గుర్తించదగిన నేరం చేయడానికి ప్రేరేపించడం లేదా ఏదైనా నేరం దర్యాప్తును నిరోధించడం లేదా ఇతర దేశాన్ని అవమానించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 12.7500pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ix)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరొక వ్యక్తిలా నటించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (x)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సాఫ్ట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేర్ వైరస్ లేదా అంతరాయం కలిగించడానికి రూపొందించబడిన ఏదైనా ఇతర కంప్యూటర్ కోడ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఫైల్ లేదా ప్రోగ్రామ్ను కలిగి ఉండటం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 12.7500pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఒక సేకరణ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంకలనం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డేటాబేస్ లేదా డైరెక్టరీని ప్రత్యక్షంగా లేదా పరోక్షంగా సృష్టించడానికి లేదా సంకలనం చేయడానికి వేదిక నుండి విషయాలను క్రమబద్ధంగా తిరిగి పొందడంలో పాల్గొనడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 13.9500pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలను </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(A) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా చట్టవిరుద్ధమైన రీతిలో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (B) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మోసపూరిత లేదా హానికరమైన కార్యకలాపాలకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(C) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలకు విరుద్ధంగా ఏ విధంగానైనా ఉపయోగించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 15.1500pt left blank 22.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xiii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్తించే చట్టాలను ఏ విధంగానైనా ఉల్లంఘించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక యొక్క యాక్సెస్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కు అంతరాయం కలిగించే లేదా భంగం కలిగించే ఏ కార్యకలాపంలో మీరు పాల్గొనకూడదని మీరు హామీ ఇస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదికలోని ఏదైనా భాగం లేదా లక్షణానికి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదికకు అనుసంధానించబడిన ఏవైనా ఇతర వ్యవస్థలు లేదా నెట్వర్క్లకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా సర్వర్లకు లేదా వేదిక ద్వారా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">హ్యాకింగ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పాస్వర్డ్ మైనింగ్ లేదా మరే ఇతర చట్టవిరుద్ధమైన మార్గాల ద్వారా అనధికారిక ప్రాప్యతను పొందడానికి మీరు ప్రయత్నించకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;">
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        8.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేధో సంపత్తి హక్కులు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నుండి ఉత్పన్నమయ్యే అన్ని మేధో సంపత్తి హక్కులతో సహా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో మరియు వాటిపై ఉన్న అన్ని హక్కులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">శీర్షిక మరియు ఆసక్తి మాకు స్వంతం లేదా ఇతరత్రా లైసెన్స్ ఇవ్వబడ్డాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలకు అనుగుణంగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు మరియు కాలానుగుణంగా జారీ చేయబడిన దాని వ్రాతపూర్వక సూచనలకు అనుగుణంగా వేదిక</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను ఉపయోగించడానికి మేము మీకు ప్రత్యేకం కాని</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బదిలీ చేయలేని</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సబ్ లైసెన్స్ పొందలేని</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">రాయల్టీ రహిత</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉపసంహరించుకోదగిన మరియు పరిమిత లైసెన్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను మంజూరు చేస్తాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక లేదా సేవలకు సంబంధించిన సూచనలు మరియు బగ్ నివేదికలతో సహా ఇతర అభిప్రాయాలను </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">అభిప్రాయం</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఎప్పటికప్పుడు సమర్పించమని మేము మిమ్మల్ని అభ్యర్థించవచ్చు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అటువంటి అభిప్రాయానికి మీరు మాకు సంపూర్ణ హక్కు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">టైటిల్ మరియు ఆసక్తిని మరియు అటువంటి అభిప్రాయం ఆధారంగా ఏవైనా అభివృద్ధిని సృష్టించే ప్రత్యేక హక్కును ఇందుమూలంగా అప్పగిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము అభిప్రాయాన్ని స్వేచ్ఛగా ఉపయోగించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కాపీ చేయవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వెల్లడించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రచురించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రదర్శించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పంపిణీ చేయవచ్చు మరియు దుర్వినియోగం చేయవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలలో పేర్కొన్నది తప్ప</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలలోని ఏదీ మా లేదా ఏదైనా మూడవ పక్షం యొక్క మేధో సంపత్తి హక్కులలో ఏదైనా హక్కు లేదా లైసెన్స్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను ప్రదానం చేస్తున్నట్లుగా భావించకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        9.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నియమం మరియు రద్దు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు ఇక్కడ పేర్కొన్న నిబంధనలకు అనుగుణంగా రద్దు చేయబడకపోతే తప్ప అమలులో ఉంటాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఈ నిబంధనల క్రింద ఉన్న ఏవైనా జవాబుదారీలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బాధ్యతలు లేదా ఒడంబడికలను ఉల్లంఘించినా లేదా అతిక్రమించినా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా మీరు మా సేవలు లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">యొక్క వినియోగదారుగా మారడం ఆపివేసినా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా దానిలోని ఏదైనా భాగానికి మీ యాక్సెస్ లేదా వినియోగాన్ని మేము వెంటనే మరియు ఏ సమయంలోనైనా మా స్వంత అభీష్టానుసారం రద్దు చేయవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనల రద్దు తర్వాత</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రొఫైల్ గడువు ముగుస్తుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమయం ముగిసిపోతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మరియు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 12.7500pt left blank 18.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు రద్దు అవుతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ముగింపు లేదా గడువు ముగిసే వరకు స్పష్టంగా లేదా మనుగడ సాగించడానికి ఉద్దేశించిన నిబంధనలు తప్ప</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        10.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిరాకరణలు మరియు వారెంటీలు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ద్వారా అందుబాటులో ఉంచబడిన ఏదైనా ఆర్థిక సమాచారం యొక్క ఖచ్చితత్వం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుకూలత</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా తప్పులు లేకుండా ఉండడానికి మేము హామీ ఇవ్వము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:147%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AMD Sandbox</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను మేము </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉన్నది ఉన్నట్లుగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏ రకమైన</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">స్పష్టమైన</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పరోక్ష</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">చట్టబద్ధమైన లేదా ఇతరత్రా వారంటీ లేకుండా అందిస్తున్నాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇందులో టైటిల్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మామ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉల్లంఘన</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వర్తకం లేదా నిర్దిష్ట ప్రయోజనం కోసం ఫిట్నెస్ యొక్క పరోక్ష హామీలు కూడా ఉన్నాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీ దరఖాస్తులతో లేదా మీరు అందించే ఏదైనా ఇతర హార్డ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సాఫ్ట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సిస్టమ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లు లేదా డేటాతో కలిపి పనిచేస్తాయని మేము హామీ ఇవ్వము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇంటర్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నెట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">తో సహా ఉత్తరప్రత్యుత్తర సౌకర్యాలపై డేటా బదిలీని మేము నియంత్రించమని మరియు సేవలు అటువంటి ఉత్తరప్రత్యుత్తరాల సౌకర్యాల వాడకంలో అంతర్లీనంగా ఉన్న పరిమితులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వాయిదాలు మరియు ఇతర సమస్యలకు లోబడి ఉండవచ్చని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పైన పేర్కొన్న వాటికి పరిమితం చేయకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము వీటికి హామీ ఇవ్వము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదిక</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లో ఉన్న విధులు మీ అవసరాలు లేదా అంచనాలను తీరుస్తాయి లేదా సేవలు లేదా శాండ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బాక్స్ యొక్క మీ వినియోగం అంతరాయం లేకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సకాలంలో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సురక్షితంగా లేదా దోష రహితంగా ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదికలో ఏవైనా తప్పులు లేదా లోపాలు ఉంటే సరిచేయబడతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా నుండి మీరు పొందిన మౌఖిక లేదా వ్రాతపూర్వక సలహా లేదా సమాచారం నిబంధనలలో స్పష్టంగా పేర్కొనబడని ఎటువంటి వారంటీని సృష్టించదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు సేవలను మరియు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను ఉపయోగించడం వల్ల తలెత్తే ఏవైనా పరిణామాలకు పూర్తి బాధ్యతను మీరు ఇందుమూలంగా అంగీకరిస్తున్నారు మరియు ఈ విషయంలో మాకు ఎటువంటి బాధ్యత ఉండదని స్పష్టంగా అంగీకరిస్తున్నారు మరియు గుర్తిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.8000pt ;line-height:144%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆర్థిక సమాచార ప్రదాత నుండి కోరిన కొంత ఆర్థిక సమాచారం ప్రాసెస్ చేయబడి ఉండవచ్చని లేదా నిజ సమయ సమాచారాన్ని కలిగి ఉండకపోవచ్చు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డీమ్యాట్ ఫోలియోల మాదిరిగా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అందువల్ల తగిన విధంగా ప్రతిబింబించకపోవచ్చునని మీరు ఇందుమూలంగా అర్థం చేసుకున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">దీనిని మా సేవల్లో లోపంగా భావించకూడదు మరియు తదనుగుణంగా మేము అందించే సమాచారంపై ఆధారపడాలి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 10.8500pt ;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">చట్టం ద్వారా అనుమతించబడిన పూర్తి స్థాయి మేరకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా అనుబంధ సంస్థలు మరియు సంబంధిత పార్టీలు ఈ క్రింది వాటి వల్ల లేదా వాటి కారణంగా ఉత్పన్నమయ్యే ఏదైనా నష్టం లేదా హానికి మీ పట్ల అన్ని బాధ్యతలను నిరాకరిస్తాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు సేవలను లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉపయోగించడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉపయోగించలేకపోవడం లేదా లభ్యత లేదా లభ్యత లేకపోవడం లేదా మీ తిరస్కరణ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డౌన్ టైమ్ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పనిచేయకపోవడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మోసం లేదా నిర్లక్ష్యంతో సహా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవల నుండి లేదా సేవల ద్వారా సమాచారం యొక్క కార్యకలాపాలు లేదా ప్రసారంలో ఏదైనా లోపం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అంతరాయం లేదా జాప్యం సంభవించడం లేదా ఉనికి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉత్తరప్రత్యుత్తర వైఫల్యం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">దొంగతనం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">విధ్వంసం లేదా సేవలకు సంబంధించిన మా రికార్డులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రోగ్రామ్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సర్వర్ లేదా ఇతర మౌలిక సదుపాయాలకు అనధికార ప్రాప్యత</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లేదా</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏ సమయంలోనైనా పనిచేయడంలో వైఫల్యం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా అనుకోని విపత్కర సంఘటనలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">షెడ్యూల్ చేయబడిన డౌన్ టైమ్ మరియు షెడ్యూల్ చేయని డౌన్ టైమ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-left:9.0000pt;tab-stops:left blank 18.0000pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలను ప్రభావితం చేసే వర్తించే చట్టంలో మార్పు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-left:9.0000pt;tab-stops:left blank 13.7000pt left blank 18.0000pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కస్టమర్ సమ్మతిని రద్దు చేయడం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇక్కడ ఉన్నదానికి విరుద్ధంగా ఏదైనా ఉన్నప్పటికీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు లేదా సేవలకు సంబంధించి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రత్యక్షంగా లేదా పరోక్షంగా లేదా ఏ విధంగానైనా సంబంధించి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏవైనా పరోక్ష</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">యాదృచ్ఛిక</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రత్యేక లేదా పర్యవసాన నష్టాలకు లేదా ఏదైనా ఆదాయం లేదా లాభాల నష్టానికి మేము లేదా మా అనుబంధ సంస్థలు లేదా సంబంధిత పార్టీలు మీకు లేదా ఏదైనా మూడవ పక్షానికి ఎటువంటి బాధ్యత వహించవు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రత్యక్ష నష్టాలకు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">చర్య యొక్క రూపంతో సంబంధం లేకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా బాధ్యత </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఒప్పందంలో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">టార్ట్ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నిర్లక్ష్యంతో సహా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">)} INR 10,000 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మించకూడదని మీరు అంగీకరిస్తున్నారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇక్కడ ఉన్న ఏదైనా పరిమిత పరిహారం యొక్క ముఖ్యమైన ప్రయోజనం విఫలమైనప్పటికీ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పైన పేర్కొన్న బాధ్యత పరిమితులు వర్తిస్తాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 12.0500pt ;line-height:144%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఈ వేదికను </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ను యాక్సెస్ చేసే ప్రయోజనాల కోసం ఉపయోగిస్తుంటే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా ఆఫర్లను మీరు మూల్యాంకనం చేయడానికి మాత్రమే మా వద్ద </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అందుబాటులో ఉందని మీరు అర్థం చేసుకుంటారు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఎట్టి పరిస్థితుల్లోనూ దీనిని వాణిజ్య సేవగా పరిగణించకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు మా ఆఫర్ల చందాను ఉపయోగించుకోవాలనుకుంటే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లభ్యంలో కలిగి ఉండాలనుకుంటే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">sup</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">port@cookie</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">j</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">ar.co.in</span>
                </u>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:6.0000pt;tab-stops:left blank 13.2500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        11.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నష్టపరిహారం</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వేదికకు మీ యాక్సెస్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సేవలు లేదా </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వాడకం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలను ఉల్లంఘించడం లేదా మీరు లేదా సేవలను యాక్సెస్ చేయడానికి మీ ప్రొఫైల్ను ఉపయోగించగల మూడవ పక్షం ద్వారా ఈ నిబంధనల ఉల్లంఘన కారణంగా లేదా వాటి వల్ల ఉత్పన్నమయ్యే ఏదైనా దావా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డిమాండ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వ్యాజ్యాలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">న్యాయపరమైన చర్యలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నష్టాలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బాధ్యతలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నష్టాలు మరియు ఖర్చులు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పరిమితి లేకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అన్ని నష్టాలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బాధ్యతలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పరిష్కారాలు మరియు న్యాయవాదుల రుసుములతో సహా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నుండి మీరు మా మాతృ సంస్థ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుబంధ సంస్థలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుబద్ధ సంస్థలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గ్రూప్ కంపెనీలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">జాయింట్ వెంచర్లు మరియు వారి అధికారులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉద్యోగులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డైరెక్టర్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏజెంట్లు మరియు ప్రతినిధులను నష్టపరిహారం చెల్లించాలి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా ఎంపిక ప్రకారం సమర్థించాలి మరియు మమ్మల్ని</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా మాతృ సంస్థను</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుబంధ సంస్థలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుబద్ధ సంస్థలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">గ్రూప్ కంపెనీలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">జాయింట్ వెంచర్లు మరియు వారి అధికారులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఉద్యోగులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డైరెక్టర్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏజెంట్లు మరియు ప్రతినిధులను నష్టాలకు బాధ్యత లేకుండా ఉంచాలి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:6.0000pt;tab-stops:left blank 13.2500pt ;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        12.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పాలించు చట్టం మరియు విభేదాల పరిష్కారం</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.5500pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ ఒప్పందం అనేది భారతదేశంలోని చట్టాలకు లోబడి మరియు వాటి ప్రకారం చేయబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలోని ఇతర నిబంధనలకు లోబడి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు లేదా సేవల వినియోగం వల్ల ఉత్పన్నమయ్యే అన్ని సమస్యలపై పూణేలోని కోర్టులు ప్రత్యేక అధికార పరిధిని కలిగి ఉంటాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 12.0500pt ;line-height:144%;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనల నుండి ఉత్పన్నమయ్యే ఏవైనా వివాదాలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంఘర్షణలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వివాదాలు లేదా విభేదాలను ప్రస్తుతానికి అమలులో ఉన్న ఆర్బిట్రేషన్ మరియు కన్సిలియేషన్ చట్టం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 1996 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్రకారం పూణేలో మధ్యవర్తిత్వం ద్వారా పరిష్కరించబడతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇది ఈ నిబంధనలో సూచన ద్వారా చేర్చబడినట్లు పరిగణించబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మధ్యవర్తిత్వ భాష ఆంగ్లం అయి ఉండాలి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.3000pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మధ్యవర్తిత్వానికి సంబంధించిన పార్టీలు మధ్యవర్తిత్వాన్ని గోప్యంగా ఉంచాలి మరియు చట్టం ప్రకారం అలా చేయవలసి వస్తే తప్ప</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అవసరం ఆధారంగా లేదా న్యాయ సలహాదారులకు తప్ప మరెవరికీ వెల్లడించకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మధ్యవర్తి నిర్ణయం తుది మరియు దీనికి సంబంధించిన అన్ని పార్టీలపై కట్టుబడి ఉంటుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.8000pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా వివాదానికి సంబంధించి మధ్యవర్తిత్వంలోని ప్రతి పక్షం దాని స్వంత ఖర్చులను భరించాలి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆన్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లైన్ డిస్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ప్యూట్ రిజొల్యూషన్ </span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">OPR</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వద్ద కూడా వివాదాన్ని లేవనెత్తవచ్చు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-bottom:6.0000pt;tab-stops:left blank 13.0000pt ;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        13.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఫిర్యాదుల పరిష్కారం</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.5500pt ;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు ఏదైనా ఫిర్యాదును లేవనెత్తాలనుకుంటే దయచేసి వెబ్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సైట్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లోని ఫిర్యాదు ఎంపికను చూడండి</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఎటువంటి సందర్భంలో అయినా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఫిర్యాదు చేసిన తేదీ నుండి </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">30 (</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ముప్పై</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">రోజులలోపు మీ ఫిర్యాదు పరిష్కరించబడేలా మేము నిర్ధారిస్తాము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆ వ్యవధిలోపు ఫిర్యాదు పరిష్కరించబడకపోతే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు క్రింద పేర్కొన్న చిరునామాలలో </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">RBI</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">కి అప్పీల్ చేసుకోవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;">
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <div align=center>
                <table class=MsoNormalTable border=0 cellspacing=0 style="border-collapse:collapse;mso-table-layout-alt:fixed;border:none;
mso-padding-alt:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;">
                    <tr style="height:16.3000pt;">
                        <td width=466 valign=center colspan=2 style="width:279.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 align=center style="margin-bottom:0.0000pt;text-align:center;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ముంబై </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">(</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ప్రాంతీయ కార్యాలయం</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">)</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">అధికార పరిధి</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">మహారాష్ట్ర రాష్ట్రం మరియు గోవా రాష్ట్రం</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:15.8500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">చిరునామా</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">3</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">వ అంతస్తు</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, RBI </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">భవనం</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ముంబై సెంట్రల్ రైల్వే స్టేషన్ ఎదురుగా</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">మరాఠా మందిర్ దగ్గర</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">బైకుల్లా</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ముంబై </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">- 400 008</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.1000pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">టెలిఫోన్</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022-2308 4121/2302 8436</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.3000pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ఫ్యాక్స్</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022-2302 2011</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ఇ</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">-</span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">మెయిల్</span>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=22 style="margin-bottom:0.0000pt;">
                                <span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;">
                                    <a href="mailto:dnbsmro@rbi.or">dnbsmro@rbi.or</a>
                                </span>
                                <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">g</span>
                                <u>
                                    <span class="18" style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;">.in</span>
                                </u>
                                <span style="font-family:'Anek Telugu';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                </table>
            </div>
            <p class=MsoNormal style="margin-bottom:3.9500pt;line-height:0.0500pt;mso-line-height-rule:exactly;">
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:'Courier New';
color:rgb(0,0,0);font-size:12.0000pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-bottom:9.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        14.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇతరత్రా నిబంధనలు</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.8000pt ;line-height:144%;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">సవరణ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలను ఎప్పుడైనా సవరించడానికి మరియు సేవల వినియోగంపై కొత్త లేదా అదనపు నిబంధనలు లేదా షరతులను జోడించడానికి మాకు హక్కు ఉంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అటువంటి మార్పులు మరియు అదనపు నిబంధనలు మరియు షరతులు మీకు తెలియజేయబడతాయి మరియు స్పష్టంగా తిరస్కరించబడితే తప్ప </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు ముగుస్తాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">), </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వెంటనే అమలులోకి వస్తాయి మరియు ఈ నిబంధనలలో చేర్చబడతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీరు అలాంటి మార్పులను అంగీకరించడానికి నిరాకరిస్తే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలు రద్దు చేయబడతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">విడివిడి పద్ధతి</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలలోని ఏదైనా నిబంధన ఏదైనా కోర్టు లేదా ఇతర సమర్థ అధికారం ద్వారా చట్టవిరుద్ధం లేదా అమలు చేయలేనిది అని నిర్ధారించబడితే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలలోని ఇతర నిబంధనలు అమలులో కొనసాగుతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా చట్టవిరుద్ధమైన లేదా అమలు చేయలేని నిబంధన దానిలో కొంత భాగాన్ని తొలగిస్తే చట్టబద్ధమైనది లేదా అమలు చేయదగినది అయితే</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆ భాగం తొలగించబడినట్లు పరిగణించబడుతుంది మరియు మిగిలిన నిబంధన అమలులో కొనసాగుతుంది </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అది నిబంధన యొక్క స్పష్టమైన ఉద్దేశ్యానికి విరుద్ధంగా ఉంటే తప్ప</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంబంధిత నిబంధన మొత్తం తొలగించబడినట్లు పరిగణించబడుతుంది</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">).</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">అసైన్మెంట్</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా ముందస్తు వ్రాతపూర్వక అనుమతి లేకుండా మీరు ఈ నిబంధనల ప్రకారం వారి హక్కులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బాధ్యతలు లేదా ఒప్పందాలను ఏ విధంగానూ లైసెన్స్ ఇవ్వకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">విక్రయించకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">బదిలీ చేయకూడదు లేదా కేటాయించకూడదు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మేము ఈ సమ్మతిని మా స్వంత అభీష్టానుసారం మరియు మేము సముచితమని భావించే ఏవైనా షరతులకు లోబడి మంజూరు చేయవచ్చు లేదా నిలిపివేయవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మీకు ఎటువంటి ముందస్తు నోటీసు లేకుండానే మా అనుబంధ సంస్థలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుబద్ధ సంస్థలు లేదా మాతృ సంస్థలకు లేదా సేవలతో అనుబంధించబడిన ఏదైనా వ్యాపారం యొక్క ఆసక్తి ఉన్న ఎవరైనా వారసులకి మేము మా హక్కులను కేటాయించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">నోటీసులు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనల ప్రకారం మాకు సంబంధించిన అన్ని నోటీసులు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అభ్యర్థనలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">డిమాండ్లు మరియు నిర్ణయాలు </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సాధారణ కార్యాచరణ కమ్యూనికేషన్లు కాకుండా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span>
                    <a href="mailto:info@cookiejar.co.in">
                        <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">info@cookiejar.co.in</span>
                    </a>
                </span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">కు పంపబడతాయి</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.3000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">మూడవ పక్ష హక్కులు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఇక్కడ ఉన్న ఏవైనా నిబంధనలను అమలు చేయడానికి మూడవ పక్షానికి ఎటువంటి హక్కులు ఉండవు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="tab-stops:left blank 11.1000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:145%;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుకోని సందర్భం</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">మా బాధ్యతలను నిర్వర్తించడంలో లేదా మా వ్యాపారాన్ని కొనసాగించడంలో ఆలస్యం చేయడం ద్వారా మేము నిరోధించబడినా లేదా ఆలస్యం చేయబడినా</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సమ్మెలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">వినియోగ సర్వీస్ లేదా టెలికమ్యూనికేషన్ నెట్వర్క్ వైఫల్యం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">దేవుని చర్య</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">యుద్ధం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">అల్లర్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">పౌర అల్లర్లు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">హానికరమైన నష్టం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఏదైనా చట్టం లేదా ప్రభుత్వ ఆదేశం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నియమం</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">నియంత్రణ లేదా దిశకు అనుగుణంగా ఉండటం వంటి మా సహేతుక నియంత్రణకు మించిన చర్యలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">సంఘటనలు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లోపాలు లేదా ప్రమాదాల ద్వారా మేము మీకు ఎటువంటి బాధ్యత వహించము</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. ("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనుకోని విపత్కర సంఘటన</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">")</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">అనువాదాలు</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనలను మరింత వివరంగా అర్థం చేసుకోవడంలో మీకు సహాయపడటానికి మాత్రమే మేము ఈ నిబంధనల యొక్క అనువాద వెర్షన్</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Telugu">&#8204;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">లను మీకు అందించవచ్చు</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఈ నిబంధనల యొక్క ఆంగ్ల వెర్షన్ మరియు ఏదైనా అనువదించబడిన వెర్షన్ మధ్య ఏదైనా అసమానత ఉన్న సందర్భంలో</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ఆంగ్ల వెర్షన్ యొక్క నిబంధనలు చెల్లుతాయి</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Telugu';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
        </div>
        <!--EndFragment-->
    </body>
</html>
    `,
};
